import { LogLevel } from '@optimizely/js-sdk-logging';
import { createInstance } from '@optimizely/react-sdk';

const optimizely = createInstance({
  logLevel: LogLevel.WARNING,
  datafile: window.optimizelyDatafile,
});

export default optimizely;
